/* eslint-disable no-console */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import { FaSearch, FaTwitter } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import H1 from '../../components/h1';
import P from '../../components/p';
import Spacer from '../../components/spacer';
import SmallButton from '../../components/smallButton';
import Button from '../../components/button';
import AppState from '../../store/appstate';
import { getUserMeta } from '../../api/queries';
import Select from '../../components/select';

function AddTwitter() {
  const { t } = useTranslation('onboarding');
  const history = useHistory();
  const apiUrl = process.env.REACT_APP_API;
  const twitterResult = AppState.useState((s) => s.addAccount.twitter);

  const userMeta = getUserMeta();

  let title = t('onboarding:add-twitter-header1');
  let desc = t('onboarding:add-twitter-desc1');

  switch (userMeta?.data?.role) {
    case 'Label':
    case 'Manager':
      title = t('onboarding:add-twitter-header2');
      desc = t('onboarding:add-twitter-desc2');

      break;
    default:
      break;
  }

  const getSelectOptions = (query) => new Promise((resolve, reject) => {
    if (!query) {
      resolve([]);
      return;
    }
    fetch(`${apiUrl}/twitter?s=${query.replace('@', '')}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => response.json())
      .then((user) => {
        if (user.errors) {
          reject(user.errors);
        }
        resolve([{ value: JSON.stringify(user), name: user.data.name, photo: user.data.profile_image_url }]);
      })
      .catch(reject);
  });

  return (
    <div className="container mx-auto">
      <div className="flex flex-col justify-center items-center text-white p-4 text-center min-h-screen-minus-footer">

        <p className="text-white text-6xl"><FaTwitter /></p>

        <Spacer />
        {!twitterResult
            && (
              <>
                <H1>{title}</H1>
                <Spacer />
                <P>{desc}</P>
                <Spacer />
                <div className="relative w-full flex flex-col items-center justify-center">
                  <div className="w-full lg:w-1/3">
                    <div className="w-full flex flex-row items-start justify-center text-sentric-dark-gray">
                      <Select
                        debounce={1000}
                        onChange={(artist) => {
                          AppState.update((s) => { s.addAccount.twitter = artist; });
                        }}
                        getOptions={getSelectOptions}
                        placeholder="@"
                        search
                      />
                      <div className="text-white text-xl ml-4 bg-sentric-dark-gray rounded-full p-4 -mt-1"><FaSearch /></div>
                    </div>
                  </div>
                </div>
              </>
            )}
        {!!twitterResult
            && (
              <>
                <H1>{t('onboarding:selected-twitter-profile')}</H1>
                <Spacer />
                <div className="bg-white rounded-lg shadow-lg flex flex-col p-4 px-6 items-center text-sentric-dark-gray">
                  {JSON.parse(twitterResult).data.profile_image_url && JSON.parse(twitterResult).data.profile_image_url.length > 0
                     && (
                     <img
                       className="w-20 h-20 object-cover rounded-full mb-4"
                       alt={JSON.parse(twitterResult).data.name}
                       src={JSON.parse(twitterResult).data.profile_image_url}
                     />
                     )}
                  {(!JSON.parse(twitterResult).data.profile_image_url)
                    && <div className="w-20 h-20 bg-gray-300 rounded-full mb-4" />}
                  <p className="font-bold mb-4">{JSON.parse(twitterResult).data.name}</p>
                  <SmallButton onClick={() => { AppState.update((s) => { s.addAccount.twitter = null; }); }}>{t('common:remove')}</SmallButton>
                </div>

              </>
            )}
        <Spacer />

        <div className="flex flex-row">
          <Button onClick={() => history.push('/add-account-6')}>{t('common:_done')}</Button>
        </div>

      </div>
    </div>
  );
}

export default AddTwitter;
